import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const DetalleAprendiz = () => {
  const { id } = useParams();
  const [aprendiz, setAprendiz] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAprendiz = async () => {
      try {
        const { data } = await axios.get(`/api/aprendices/listid/${id}`);
        if (data.ok) {
          setAprendiz(data.message);
        } else {
          console.error('No se encontró el aprendiz.');
        }
      } catch (error) {
        console.error('Error al obtener los datos:', error.message);
      }
    };
    fetchAprendiz();
  }, [id]);

  return (
    <div className="container py-5 px-5 shadow-lg rounded-4 bg-light mt-5 mb-5">
      <h2>Detalle del Aprendiz</h2>
      {aprendiz ? (
        <div>
          <div className="row">
            {/* Primera columna */}
            <div className="col-md-4">
              <p><strong>Documento:</strong> {aprendiz.documentoAprendiz}</p>
              <p><strong>Tipo de Documento:</strong> {aprendiz.tipodocumentoAprendiz}</p>
              <p><strong>Nombre Completo:</strong> {`${aprendiz.nombre1Aprendiz} ${aprendiz.nombre2Aprendiz || ''} ${aprendiz.apellido1Aprendiz} ${aprendiz.apellido2Aprendiz || ''}`}</p>
              <p><strong>Edad:</strong> {aprendiz.edadAprendiz}</p>
              <p><strong>Sexo:</strong> {aprendiz.sexoAprendiz}</p>
              <p><strong>Dirección:</strong> {aprendiz.direccionAprendiz}</p>
              <p><strong>Teléfono 1:</strong> {aprendiz.telefono1Aprendiz}</p>
            </div>

            {/* Columna central con imagen */}
            <div className="col-md-4 mt-5">
              {aprendiz.imgAprendiz ? (
                <img
                  src={aprendiz.imgAprendiz}
                  alt="Foto del Aprendiz"
                  className="img-fluid rounded-circle shadow mb-3"
                  style={{ width: '200px', height: '200px', objectFit: 'cover' }}
                />
              ) : (
                <p className="text-muted">Sin imagen disponible</p>
              )}
            </div>

            {/* Segunda columna */}
            <div className="col-md-4">
              <p><strong>Teléfono 2:</strong> {aprendiz.telefono2Aprendiz || 'N/A'}</p>
              <p><strong>Fecha de Nacimiento:</strong> {new Date(aprendiz.fechanacimientoAprendiz).toLocaleDateString('es-CO')}</p>
              <p><strong>RH:</strong> {aprendiz.rhAprendiz}</p>
              <p><strong>Email:</strong> {aprendiz.emailAprendiz}</p>
              <p><strong>País:</strong> {aprendiz.paisAprendiz}</p>
              <p><strong>Estado:</strong> {aprendiz.estadoAprendiz}</p>
              <p><strong>Ciudad:</strong> {aprendiz.ciudadAprendiz}</p>
            </div>
          </div>

          <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>Volver</button>
        </div>
      ) : (
        <p>Cargando información del aprendiz...</p>
      )}
    </div>
  );
};

export default DetalleAprendiz;
